import { render, staticRenderFns } from "./managementNumber.vue?vue&type=template&id=537dd3ec&scoped=true&"
import script from "./managementNumber.vue?vue&type=script&lang=js&"
export * from "./managementNumber.vue?vue&type=script&lang=js&"
import style0 from "./managementNumber.vue?vue&type=style&index=0&id=537dd3ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537dd3ec",
  null
  
)

export default component.exports